/**
 * @override King Living: Icon Set appearance (CF-053 / CF-054).
 * `heading` is the storefront section title (`title` stays CMS-only, not queried).
 * Style group: `textColour`, `backgroundColour`.
 */

import gql from 'graphql-tag';

export const BaseIconSetFragment = gql`
  fragment BaseIconSetFragment on IconSet {
    __typename
    sys {
      id
    }
    appearance
    heading
    textColour
    backgroundColour
    jumpLink
    jumpLinkMarginTop
    maxItemsPerRowDesktop
  }
`;
